import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);
  const toggleMenu = () => setIsOpen((v) => !v);

  // Close on Escape
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeMenu();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <Nav aria-label="Mobile navigation">
      <TopBar>
        <Hamburger
          type="button"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          onClick={toggleMenu}
          $open={isOpen}
        >
          <span />
          <span />
          <span />
        </Hamburger>
      </TopBar>

      {isOpen && <Overlay onClick={closeMenu} />}

      <Panel $open={isOpen} role="dialog" aria-modal="true">
        <MenuList>
          <MenuItem>
            <MenuLink to="/about" end onClick={closeMenu}>
              ABOUT
            </MenuLink>
          </MenuItem>

          <MenuItem>
            <MenuLink to="/self-hypnosis" onClick={closeMenu}>
              SELF HYPNOSIS
            </MenuLink>
          </MenuItem>

          <MenuItem>
            <MenuLink to="/hypnotherapy" onClick={closeMenu}>
              HYPNOTHERAPY
            </MenuLink>
          </MenuItem>

          <MenuItem>
            <MenuLink to="/group-hypnosis" onClick={closeMenu}>
              GROUP HYPNOSIS
            </MenuLink>
          </MenuItem>
        </MenuList>
      </Panel>
    </Nav>
  );
};

const Nav = styled.nav`
  position: relative;

  @media (min-width: 1000px) {
    display: none;
  }
`;
const TopBar = styled.div`
  padding: 10px 12px;
  display: flex;
  justify-content: flex-start;
`;


const Hamburger = styled.button`
  cursor: pointer;
  width: 44px;
  height: 44px;
  border-radius: 999px;

  background: transparent;
  border: 1px solid transparent;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  padding: 10px;

  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;
  z-index: 10010;

  &:hover {
    background: rgba(255, 119, 200, 0.12);
    border-color: var(--border);
    transform: translateY(-1px);
  }

  span {
    display: block;
    height: 2px;
    width: 100%;
    background: var(--ink);
    border-radius: 999px;
    transition: transform 200ms ease, opacity 200ms ease;
    transform-origin: center;
  }

  /* Animate into X */
  span:nth-child(1) {
    transform: ${({ $open }) => ($open ? "translateY(9px) rotate(45deg)" : "none")};
  }
  span:nth-child(2) {
    opacity: ${({ $open }) => ($open ? 0 : 1)};
  }
  span:nth-child(3) {
    transform: ${({ $open }) => ($open ? "translateY(-9px) rotate(-45deg)" : "none")};
  }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(31, 27, 22, 0.28);
  backdrop-filter: blur(2px);
  z-index: 10000;
`;

const Panel = styled.div`
  position: fixed;
  top: 62px;
  left: 50%;
  transform: translateX(-50%);
  width: min(560px, calc(100% - 24px));

  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;

  padding: 14px;
  z-index: 10020;

  box-shadow: 0 16px 45px rgba(0, 0, 0, 0.18);

  display: ${({ $open }) => ($open ? "block" : "none")};
`;

const MenuList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const MenuItem = styled.li`
  width: 100%;
`;

const MenuLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  padding: 14px 16px;
  border-radius: 999px;

  font-family: var(--font-heading), sans-serif;
  font-weight: 800;
  letter-spacing: 0.02em;
  font-size: 1.5rem;
  line-height: 1.1;

  color: var(--ink);
  background: transparent;
  border: 1px solid transparent;

  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;

  &:hover {
    background: rgba(255, 119, 200, 0.12);
    border-color: var(--border);
    transform: translateY(-1px);
  }

  &.active {
    background: rgba(43, 189, 95, 0.10); /* soft green */
    border-color: var(--border);
  }

  /* Accent dot (optional, but nice) */
  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 99px;
    margin-left: 10px;
    background: transparent;
    transition: background 160ms ease;
  }

  &:hover::after {
    background: var(--brand-pink);
  }

  &.active::after {
    background: var(--brand-green);
  }

  @media (min-width: 500px) {
    font-size: 2rem;
  }
`;

export default Navbar;
